module.exports = require('./MessengerAlertErrorView');
